import React from "react";

const Overlay = ({ children, close }) => {
	return (
		<div
			className="fixed top-0 left-0 w-full h-full bg-[#000]/[0.90]  z-50 flex overflow-y-scroll xl:overflow-y-visible justify-center items-center py-10 px-0 xl:py-0"
			onClick={close}
		>
			{children}
		</div>
	);
};

export default Overlay;

//Please don't remove
// Overlay classname------>
